import axios from 'axios'
import {
  AllCompanies,
  BulkBedCreation,
  bulkpackageconfig,
  bulkparameterconfig,
  bulkparameterrangeconfig,
  bulktestconfig,
} from '../features/bedManagement/endpoints/EndPoints'
import KeycloakService from '../utils/keycloakService'
import { lmsIntent, sucessErrorMsg } from './constants'
import { startSxpProxy } from '../utils/api'
import { ADMIN_PROJECT_ID } from '../utils/constants'
import { GET_COMPANY_BY_ID } from '../utils/Endpoints'
import { OrganizationIntent } from '../features/administration/constants'

export const GetAllCompanies = async () => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${AllCompanies}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      data: response?.data?.company,
      success: true,
      message: sucessErrorMsg?.companySucessMsg,
    }
  } catch {
    return {
      data: null,
      success: false,
      message: sucessErrorMsg?.companyErrorMsg,
    }
  }
}
export const getAllPriceList = async (): Promise<any[]> => {
  try {
    const state = {}
    const data = await startSxpProxy(
      ADMIN_PROJECT_ID,
      lmsIntent?.getAllPriceList,
      state
    )
    const pricelist: any[] = Array?.isArray(data?.data)
      ? data?.data
      : Array?.isArray(data)
      ? data
      : []
    return pricelist
  } catch (error) {
    console.error(error)
    return []
  }
}
export const getLocByid = async (locationId: string) => {
  try {
    const state = { location: locationId }
    const data = await startSxpProxy(
      ADMIN_PROJECT_ID,
      lmsIntent?.GetLocByID,
      state
    )
    return data?.data
  } catch (error) {
    console.error(error)
    return null
  }
}
export const getCompanyByid = async (id: string | null) => {
  const token = KeycloakService.getToken()
  try {
    const response = await axios?.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_COMPANY_BY_ID}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      data: response?.data?.company,
      success: true,
      message: sucessErrorMsg?.companySucessMsg,
    }
  } catch {
    return {
      data: null,
      success: false,
      message: sucessErrorMsg?.companyErrorMsg,
    }
  }
}
const API_BASE = process.env.REACT_APP_API_GATEWAY_URL

export const bulkUploadService = async (item: string, csvData: any[]) => {
  const keyMap: Record<string, string> = {
    beds: 'beds',
    panel: 'panels',
    labtest: 'labTests',
    testrange: 'testRanges',
    packages: 'packages',
  }

  const key = keyMap[item?.toLowerCase?.()] || 'data'
  const token = KeycloakService?.getToken()

  let finalData = csvData

  if (item?.toLowerCase() === 'packages') {
    finalData = csvData.map((row) => ({
      ...row,
      panels: [],
      lab_tests: [],
    }))
  }

  const payload = { [key]: finalData }

  let endpoint = ''
  switch (item?.toLowerCase()) {
    case 'beds':
      endpoint = `${API_BASE}${BulkBedCreation}`
      break
    case 'panel':
      endpoint = `${API_BASE}${bulktestconfig}`
      break
    case 'labtest':
      endpoint = `${API_BASE}${bulkparameterconfig}`
      break
    case 'testrange':
      endpoint = `${API_BASE}${bulkparameterrangeconfig}`
      break
    case 'packages':
      endpoint = `${API_BASE}${bulkpackageconfig}`
      break
    default:
      throw new Error(`Invalid endpoint for item: ${item}`)
  }

  const response = await axios.post(endpoint, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })

  return response?.data
}
export const getOrganizationsService = async () => {
  try {
    const response = await startSxpProxy(
      ADMIN_PROJECT_ID,
      OrganizationIntent.getAllOrganizationForAdmin,
      {}
    )

    return {
      success: true,
      data: response?.data?.organization || [],
    }
  } catch (error) {
    console.error('Error fetching organizations:', error)
    return {
      success: false,
      data: [],
    }
  }
}
export const CreateCompany = async (payload: any) => {
  try {
    const response = await startSxpProxy(
      ADMIN_PROJECT_ID,
      OrganizationIntent.createCompany,
      payload
    )

    return {
      success: true,
      data: response?.data || [],
    }
  } catch (error) {
    console.error(error)
    return {
      success: false,
      data: [],
    }
  }
}
